<div class="image">
  <img [src]="dashboardService.getDashboardInstallationImagePath(installation)" />
</div>
<div class="content">
  <div class="content__device-name gap-1 flex-wrap">
    <div class="device-name" ViEllipsis [includeHeight]="true" [showTextContentInTooltip]="true">
      {{ installationHeaderLabel }}
    </div>
    <div class="flex gap-1 flex-wrap">
      <app-pill
        data-at-status-pill
        [type]="pillType.secondaryLight"
        *ngIf="
          tileType === tileTypes.LastConnectedSystems ||
          tileType === tileTypes.InstallationsWithoutSRC
        "
      >
        {{ installation?.connectedAt | date: 'dd.MM.yy, HH:mm' }}
      </app-pill>

      <ng-container *ngIf="tileType === tileTypes.ContractsEndingSoon">
        <app-booking-package-badge
          *ngIf="dashboardService.getInstallationPackage(installation) as packageType"
          [packageType]="packageType"
          size="inline"
        ></app-booking-package-badge>
        <app-booking-package-badge
          *ngIf="installation?.isTrialSubscription"
          [packageType]="subscriptionPlan.Trial"
          size="inline"
        ></app-booking-package-badge>
        <app-pill
          data-at-status-pill
          [type]="pillType.secondaryLight"
          class="text-center no-border"
        >
          {{ searchService.getLeftDays(installation?.subscriptionExpirationDate) }}
        </app-pill>
      </ng-container>
    </div>
  </div>
  <div class="content__details">
    {{ installation?.id }},
    <span *ngIf="installation?.installationType === installationType.Residential"
      >{{ installation?.owner?.firstName }} {{ installation?.owner?.lastName }},</span
    >
    <span *ngIf="installation?.installationType === installationType.Commercial"
      >{{ installation?.commercialOwner?.companyName }} {{ installation?.owner?.lastName }},</span
    >
    {{ installation?.address?.street }} {{ installation?.address?.houseNumber }},
    {{ installation?.address?.zip }}
    {{ installation?.address?.city }}
  </div>
  <div
    *ngIf="
      tileType === tileTypes.InstallationsWithFault ||
      tileType === tileTypes.UpcomingMaintenanceForInstallations
    "
    class="content__badges"
  >
    <app-pill
      data-at-status-pill
      *ngIf="installation?.isSystemLocked"
      [type]="pillType.errorInverted"
    >
      {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.COLD_SYSTEM' | translate }}
    </app-pill>
    <app-pill
      data-at-status-pill
      *ngIf="shouldShowFaultLabelWhenNoSmartNoteError(installation)"
      [type]="pillType.error"
    >
      {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.FAULT' | translate }}
    </app-pill>
    <app-pill
      data-at-status-pill
      [type]="pillType.primary"
      *ngIf="installation?.aggregatedStatus === aggregatedStatus.Maintenance"
    >
      {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.MAINTENANCE' | translate }}
    </app-pill>
  </div>
  <ng-container *ngIf="tileType === tileTypes.InstallationsWithFault">
    <ng-container *ngIf="latestSmartNotes?.smartNotes && latestSmartNotes.smartNotes.length > 0">
      <div class="content__badges">
        <app-pill
          data-at-status-pill
          [type]="pillType.error"
          *ngFor="let smartNote of latestSmartNotes.smartNotes"
          >{{ smartNote.content.errorCode }}</app-pill
        >
        <app-pill
          matTooltip="{{
            '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.SHOW_ERROR_CODES_TOOLTIP' | translate
          }}"
          data-at-status-pill
          [type]="pillType.error"
          *ngIf="latestSmartNotes.needTooltip"
          >{{
            '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.TOOLTIP.SHOW_MORE_TXT' | translate
          }}</app-pill
        >
      </div>
    </ng-container>
  </ng-container>
  <div
    *ngIf="tileType === tileTypes.InstallationsWithAnomalies && installation.amountOfAnomalies"
    class="content__badges"
  >
    <div class="flex flex-wrap gap-1">
      <ng-container *ngFor="let device of installation.devices">
        <ng-container *ngIf="device | dashboardAnomalyPill as anomalyPills">
          <app-pill
            *ngFor="let pill of anomalyPills"
            [type]="pill.pillType"
            [matTooltip]="pill.tooltipText"
          >
            {{ pill.label }}
          </app-pill>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
